import React from 'react';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { Box, Stack, Table, TableCell, TableRow } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';

const TutorDetails = ({ open, setOpen, rowDetails }) => {
  const handleCancel = () => {
    setOpen(false);
  };
  const capitalize = (keyName) => {
    return keyName
      .replace(/([A-Z])/g, ' $1') // Insert space before each capital letter
      .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
  };

  const details = [
    { key: 'Tutor Contact Number', value: rowDetails?.trainer_mob },
    { key: 'Email', value: rowDetails?.email_id },
    { key: 'TP', value: rowDetails?.trainer_tp },
    { key: 'Last Assigned Cro', value: rowDetails?.last_assigned_cro },
    { key: 'Total Sessions', value: rowDetails?.trainer_total_sessions },
    { key: 'Course Completed', value: rowDetails?.trainer_course_completed },
    { key: 'Course Completed Student Count', value: rowDetails?.course_completed_students_count },
  ];
  return (
    <GlobalDialog
      maxWidth={'sm'}
      fullWidth
      title={'Tutor Details'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      content={
        <>
          <Table>
            <tbody>
              {details?.map(({ key, value }) => {
                return (
                  <TableRow key={key}>
                    <TableCell variant="head" sx={{ padding: 1 }}>
                      <Stack direction={'row'} spacing={1}>
                        <Box mr={1} pt={0.3}>
                          <Icon color="#080808ff" icon="icon-park-outline:dot" width="20" height="20" />
                        </Box>
                        <Box>{capitalize(key)}</Box>
                      </Stack>
                    </TableCell>
                    <TableCell sx={{ padding: 0.5 }}>: {value || 'Nill'}</TableCell>
                  </TableRow>
                );
              })}
            </tbody>
          </Table>
        </>
      }
    />
  );
};

export default TutorDetails;
